import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { MenuComponent } from './pages/menu/menu.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { TestComponent } from './test.component';
import { IframeComponent } from './pages/iframe/iframe.component';
import { StickyMenuComponent } from './sticky-menu/sticky-menu.component';


const routes: Routes = [
 
    {
      path: '',
      component: TestComponent,
      children: [
        {
          path: 'menu',
          component: MenuComponent,
          //loadChildren: () => import('./account/account.module').then(m => m.AccountModule), // Lazy load account module
          data: { preload: true }
        },
  
        {
          path: 'users',
          component: UserListComponent,
          //loadChildren: () => import('./account/account.module').then(m => m.AccountModule), // Lazy load account module
          data: { preload: true }
        },
        {
          //SubTest icin Component yuklemesi yaptigimda, yukaridaki menuler de calismaz oluyor.
          //Fakat SubTestModule olarak yukledigimde, yukaridakiler calisiyor ancak, SubTest module calismiyor.
          path: 'subtest',
          loadChildren: () => import('./sub-test/sub-test.module').then(m => m.SubTestModule), // Lazy load account module
          data: { preload: true }
        },
        {
          path: 'iframe',
          component: IframeComponent,
          data: { preload: true }
        },
        {
          path: 'sticky-menu',
          component: StickyMenuComponent,
          data: { preload: true }
        },
      ]
    }

  //{ path: '', redirectTo: '/test/menu', pathMatch: 'full' },

     
    
];


@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes),


  CommonModule
  ],
  exports: [RouterModule],
})
export class TestRoutingModule { }
